<template>
  <b-modal id="dailyPlanRedirectionModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.dailyplan.redirectionHeader') }} <span v-if="serviceman">({{ serviceman.name }} {{ serviceman.surname }})</span></h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
<!--          <label-->
<!--            for="exsbdocument_dateOfIssue"-->
<!--            class="form-control-label">{{$t('views.dailyPlan.date')}}:</label>-->
          <fg-input>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="date"
              type="date">
            </el-date-picker>
          </fg-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="btn btn-success" @click="changeDay()">{{ $t('buttons.go') }}</b-button>
        <b-button class="btn btn-danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import getId from '@/utils/getIdFromLink'

export default {
  name: 'DailyPlanRedirectionModal',
  computed: {
    show () {
      return this.$store.state.modals.dailyplan.redirection.show
    },
    servicemanObject () {
      return this.$store.state.modals.dailyplan.redirection.serviceman
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'servicemanObject': function (val) {
      this.openModal()
    }
  },
  data () {
    return {
      serviceman: null,
      date: this.$moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    changeDay () {
      this.$router.push({ name: 'DailyPlanShow', params: { idServiceman: this.getIdLink(this.serviceman['@id']), date: this.$moment(this.date).format('YYYY-MM-DD') } })
      this.closeModal()
    },
    openModal () {
      if (this.show === 1 && this.servicemanObject) {
        this.serviceman = Object.assign({}, this.servicemanObject)
        this.$store.state.modals.dailyplan.redirection.show = 0
        this.$store.state.modals.dailyplan.redirection.serviceman = {}
        this.$bvModal.show('dailyPlanRedirectionModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('dailyPlanRedirectionModal')
    },
    resetData () {
      // console.log()
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
